import script from "./TableImage.vue?vue&type=script&setup=true&lang=js"
export * from "./TableImage.vue?vue&type=script&setup=true&lang=js"

import "./TableImage.vue?vue&type=style&index=0&id=1eb08293&scoped=true&lang=css"
import "./TableImage.vue?vue&type=style&index=1&id=1eb08293&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1eb08293"]])

export default __exports__